import React, { useState } from "react";
import CloseDetailPage from "../../../components/CloseComponent/CloseDetailPage";
import DetailWrapper from "../../../components/detailWrapper";
import { Button } from "semantic-ui-react";
import OriginInputCustom from "../../../components/InputComponents/originInputCustom";
import { useNavigate } from "react-router";
import { HiChevronLeft } from "react-icons/hi";
import {
  passwordExpress,
  passwordExpressForInput,
} from "../../../regex_constanst";
import { useDispatch } from "react-redux";
import { notice } from "../../../redux/action/action";
import { useTranslation } from "react-i18next";
import { resetPassword } from "../../../api/postApi";

const ResetPassword = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`settings.${key}`);
  const i18n_common = (key) => t(`common.${key}`);
  const i18n_formHint = (key, props) => t(`formHint.${key}`, { ...props });

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [data, setData] = useState({
    old_password: "",
    new_password: "",
    new_password_again: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const { old_password, new_password, new_password_again } = data;
    if (passwordExpress.test(new_password)) {
      if (new_password === new_password_again) {
        resetPassword({
          old_pwd: old_password,
          new_pwd: new_password,
        })
          .then((data) => {
            dispatch(notice("設定成功", "success"));
            navigate("../reset-password-success");
          })
          .catch((err) => {})
          .finally(() => {});
      } else {
        dispatch(notice("兩次輸入的密碼不一致", "error"));
      }
    } else {
      dispatch(notice("密碼不符合格式（須為八位英數)", "error"));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const formData = [
    {
      name: "old_password",
      label: i18n("form.old_password"),
      type: "password",
      onChange: (e) => {
        handleChange(e);
      },
    },
    {
      name: "new_password",
      label: "New Password",
      type: "password",
      placeholder: i18n_formHint("includeEightEnglishAndNumber"),
      pattern: passwordExpressForInput,
      onChange: (e) => {
        handleChange(e);
      },
    },
    {
      name: "new_password_again",
      label: "New Password Again",
      type: "password",
      placeholder: i18n_formHint("includeEightEnglishAndNumber"),
      pattern: passwordExpressForInput,
      onChange: (e) => {
        handleChange(e);
      },
    },
  ];
  return (
    <DetailWrapper
      closeAnimate
      wrapperClassName={`h-full w-full md:absolute fixed top-0 left-0 max-h-full z-[1] bg-gradient-to-br`}
    >
      <CloseDetailPage
        hasPrev={
          <HiChevronLeft
            className="cursor-pointer"
            onClick={() => navigate("..")}
          />
        }
        title={i18n("resetPassword")}
      />
      <article className="flex flex-col gap-[10px] p-[15px]">
        <form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          {formData.map((item, index) => {
            return (
              <div>
                <span className="text-sm text-transaction-text dark:text-base-light-white font-medium">
                  {i18n(`form.${item.name}`)}
                </span>
                <OriginInputCustom
                  {...item}
                  title={item.placeholder}
                  name={item.name}
                  type={item.type}
                />
              </div>
            );
          })}
          <Button
            type="submit"
            disabled={!Object.keys(data).every((item) => data?.[item] !== "")}
            content={i18n_common("SAVE")}
            size="xl"
            className="!bg-main-color !text-white w-full !py-[17px] !mt-[20px]"
          ></Button>
        </form>
      </article>
    </DetailWrapper>
  );
};

export default ResetPassword;
